import React from 'react';

export interface TagProps extends React.CSSProperties {
  name: string;
  backgroundColor?: string;
  textColor?: string;
  height?: string;
}

const Tag = ({
  name,
  backgroundColor,
  textColor,
  height = '20px',
  ...overrideStyle
}: TagProps) => {
  return (
    <div
      style={{
        height,
        backgroundColor,
        color: textColor,
        borderRadius: '4px',
        fontWeight: 600,
        ...overrideStyle
      }}
      className="truncate"
      title={name}
    >
      <span className="truncate min-w-0 flex-1">{name}</span>
    </div>
  );
};

export default Tag;
